
// in product detail page  defination

document.addEventListener('DOMContentLoaded', function () {
  // Run only on desktop (adjust the 768px breakpoint as needed)
  if (window.innerWidth >= 768) {
    // Step 1: Get the <hdt-product-media> element
    const productMedia = document.querySelector('hdt-product-media');

    // Step 2: Get the tabs section by ID
    const tabsSection = document.querySelector('.hdt-section-main-product-tabs');

    // Step 3: Move tabs section after <hdt-product-media>
    if (productMedia && tabsSection) {
      if (productMedia.nextElementSibling !== tabsSection) {
        productMedia.parentNode.insertBefore(tabsSection, productMedia.nextSibling);
        // console.log('✅ Tabs section moved after hdt-product-media (desktop only)');
      }
    } else {
      // console.log('❌ Elements not found');
    }
  }
});


